import { apiSlice } from './baseApi';
import { DEFAULT_PAGE_LIMIT } from '@constants/appDefaults';

export const userApi = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getUsers: builder.query({
      query: ({ companyId, limit = 100 }) => ({
        url: '/users/get-all-users',
        method: 'POST',
        body: {
          company_id: companyId,
          limit,
        },
      }),
      transformResponse: (response, meta, arg) => {
        const users = response?.users || [];
        const currentUserId = arg.currentUserId;

        const filteredUsers = users.filter(
          (user) => user.username !== "Company Balance"
        );

        const transformedData = filteredUsers.map((user) => {
          const userId = user.id || user._id;
          return {
            name: userId === currentUserId
              ? `${user.username} (You)`
              : user.username,
            value: userId,
            isCurrentUser: userId === currentUserId,
            image: user.image || '',
            color: user.color || '#6366f1',
          };
        });

        transformedData.sort((a, b) => {
          if (a.isCurrentUser) return -1;
          if (b.isCurrentUser) return 1;
          return 0;
        });

        return transformedData;
      },
      providesTags: ['Users'],
    }),
    getUsersList: builder.query({
      query: ({ companyId, page = 1, limit = DEFAULT_PAGE_LIMIT, tableFilterOutcomingData = {} }) => ({
        url: '/users/get-all-users',
        method: 'POST',
        body: {
          company_id: companyId,
          page,
          limit,
          tableFilterOutcomingData,
        },
      }),
      transformResponse: (response) => ({
        users: (response?.users ?? []).map((user) => ({ ...user, _id: user._id || user.id })),
        totalPages: response?.totalPages ?? 1,
        currentPage: response?.currentPage ?? 1,
      }),
      providesTags: ['Users'],
    }),
    addUser: builder.mutation({
      query: (body) => ({
        url: '/auth/register',
        method: 'POST',
        body,
      }),
      invalidatesTags: ['Users'],
    }),
    renewStaffInvite: builder.mutation({
      query: (body) => ({ url: '/auth/staff-invite', method: 'POST', body }),
      invalidatesTags: ['Users'],
    }),
    editUser: builder.mutation({
      query: (body) => ({
        url: '/users/edit-user',
        method: 'POST',
        body,
      }),
      invalidatesTags: ['Users'],
    }),
    deleteUser: builder.mutation({
      query: (body) => ({
        url: '/users/delete-user',
        method: 'POST',
        body,
      }),
      invalidatesTags: ['Users'],
    }),
    setUserAccessStatus: builder.mutation({
      query: (body) => ({ url: '/users/access-status', method: 'POST', body }),
      invalidatesTags: ['Users'],
    }),
  }),
});
